import { WebPlugin } from '@capacitor/core';
export class KioskModeWeb extends WebPlugin {
    async isInKioskMode() { return Promise.resolve({ value: true }); }
    async enterKioskMode() { return Promise.resolve(); }
    async exitKioskMode() { return Promise.resolve(); }
    async toggleKioskMode() { return Promise.resolve(); }
}
//# sourceMappingURL=web.js.map